export enum VarnishLabelsEnum {
  NONE = 'None',
  FLAT = 'Flat',
  SPECIAL = 'Special',
  PAINT = 'Paint',
  PEARL = 'Pearl',
  LL5 = 'LL5',
  ULTRA_FLAT = 'Ultra Flat',
}
